import * as types from './mutation-types';

const searchInitial = ({ commit }, payload) => {
  commit(types.INITIAL, payload);
};
const searchInitialDetails = ({ commit }, payload) => {
  commit(types.INITIALDETAILS, payload);
};

const selectedSearch = ({ commit }, payload) => {
  commit(types.SELECTEDSEARCH, payload);
};

export default {
  searchInitial,
  searchInitialDetails,
  selectedSearch,
};



// WEBPACK FOOTER //
// ./src/store/modules/search/actions.js